import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { BiCodeAlt, BiServer, BiMobile } from 'react-icons/bi';
import { FaApple, FaAndroid, FaGlobe, FaDatabase, FaShieldAlt } from 'react-icons/fa';
import { MdPhonelink, MdDeveloperMode } from 'react-icons/md';
import { RiCloudLine } from 'react-icons/ri';
import './Header.css';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  const toggleServicesDropdown = () => {
    setIsServicesOpen(!isServicesOpen);
  };

  const handleDropdownClick = () => {
    setIsServicesOpen(false);
    setMenuOpen(false);
  };

  return (
    <header className="header" id="home">
      <nav className="nav-container">
      <div className="logo">
  <Link to="/" onClick={closeMenu} className="nav-logo-text">
    CodeProwl Technologies
  </Link>
</div>

        <div className="nav-search">
          <input type="text" placeholder="Search" className="nav-search-input" />
          <span className="nav-search-icon">🔍</span>
        </div>

        <div className="nav-buttons">
        <Link to="/ContactPage"><button className="nav-btn outline-btn">Book Consulting Services</button></Link>
        <Link to="/ContactPage"><button className="nav-btn outline-btn">Contact Us</button></Link>
        </div>

        <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
          <li><Link to="/" onClick={closeMenu}>Home</Link></li>
          <li><Link to="/about" onClick={closeMenu}>About</Link></li>

          <li className="services">
            <button className="services_button_header" onClick={toggleServicesDropdown}>
              Services
              <span className={`arrow ${isServicesOpen ? 'open' : ''}`}>▼</span>
            </button>
            {isServicesOpen && (
              <div className="services-dropdown-horizontal open">
                <div className="service-category">
                  <div className="category-title">Mobile <BiMobile /></div>
                  <ul>
                    <li><Link to="/iPhoneAppDevelopment" onClick={handleDropdownClick}><FaApple /> iPhone App Development</Link></li>
                    <li><Link to="/AndroidAppDevelopment" onClick={handleDropdownClick}><FaAndroid /> Android App Development</Link></li>
                    <li><Link to="/CrossPlatformApp" onClick={handleDropdownClick}><MdPhonelink /> Cross-Platform App Development</Link></li>
                    <li><Link to="/ServicePage" onClick={handleDropdownClick}><BiMobile /> Mobile App Development</Link></li>
                    <li><Link to="/MobileConsulting" onClick={handleDropdownClick}><MdDeveloperMode /> Mobile App Consulting</Link></li>
                  </ul>
                </div>
                <div className="service-category">
                  <div className="category-title">Website <FaGlobe /></div>
                  <ul>
                    <li><Link to="/WebDesignPage" onClick={handleDropdownClick}><FaGlobe /> Website Development</Link></li>
                    <li><Link to="/Hosting" onClick={handleDropdownClick}><RiCloudLine /> Website Hosting</Link></li>
                  </ul>
                </div>
                <div className="service-category">
                  <div className="category-title">Backend <BiServer /></div>
                  <ul>
                    <li><Link to="/Logic" onClick={handleDropdownClick}><FaDatabase /> Backend & Logic Development</Link></li>
                    <li><Link to="/Api" onClick={handleDropdownClick}><BiCodeAlt /> API Services</Link></li>
                    <li><Link to="/Security" onClick={handleDropdownClick}><FaShieldAlt /> Security</Link></li>
                  </ul>
                </div>
              </div>
            )}
          </li>

          <li><Link to="/Desktop" onClick={closeMenu}>Desktop</Link></li>
          <li><Link to="/Time" onClick={closeMenu}>Our Success Stories</Link></li>
          <li><Link to="/ContactPage" onClick={closeMenu}>Contact</Link></li>
        </ul>
{/* 
        <div className="menu-icon" onClick={toggleMenu}>
          {menuOpen ? '✖' : '☰'}
        </div> */}
      </nav>
    </header>
  );
};

export default Header;
